import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, toDisplayString as _toDisplayString, vShow as _vShow, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", { class: "heading-title" }, "Forgot Password", -1)
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 0,
  class: "form-group mb-3"
}
const _hoisted_6 = {
  for: "name",
  class: "form-label"
}
const _hoisted_7 = {
  key: 0,
  class: "input-errors"
}
const _hoisted_8 = {
  key: 1,
  class: "form-group mb-3"
}
const _hoisted_9 = { class: "credentials-list-container" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "display-text" }
const _hoisted_12 = {
  key: 2,
  class: "form-group mb-3"
}
const _hoisted_13 = {
  for: "code",
  class: "form-label"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 0,
  class: "input-errors"
}
const _hoisted_16 = {
  key: 3,
  class: "form-group mb-3"
}
const _hoisted_17 = {
  for: "securityAnswer",
  class: "form-label"
}
const _hoisted_18 = {
  key: 0,
  class: "input-errors"
}
const _hoisted_19 = { class: "captcha-container" }
const _hoisted_20 = { class: "google-recaptcha" }
const _hoisted_21 = { class: "form-group mt-4" }
const _hoisted_22 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToolTip = _resolveComponent("ToolTip")!
  const _component_vue_recaptcha = _resolveComponent("vue-recaptcha")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    (_ctx.isFormInvalid)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "alert alert-danger",
          innerHTML: _ctx.validationMsg
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true),
    (_ctx.lastDateMsg)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "alert alert-warning",
          innerHTML: _ctx.lastDateMsg
        }, null, 8, _hoisted_3))
      : _createCommentVNode("", true),
    (_ctx.isResponseValid)
      ? (_openBlock(), _createElementBlock("p", {
          key: 2,
          class: "v-code-text",
          innerHTML: _ctx.responseMessage
        }, null, 8, _hoisted_4))
      : _createCommentVNode("", true),
    _createElementVNode("form", {
      onSubmit: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["prevent"]))
    }, [
      (_ctx.step === 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("label", _hoisted_6, [
              _createTextVNode("Username "),
              _createVNode(_component_ToolTip, { tooltipText: "Enter your P&A MyBenefits username and click next to get started." })
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: _normalizeClass(["form-control type-number", _ctx.v$.user.userName.$error ? 'is-invalid' : 'input-text']),
              id: "name",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user.userName) = $event)),
              onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.user.userName.$touch()))
            }, null, 34), [
              [_vModelText, _ctx.user.userName]
            ]),
            (_ctx.v$.user.userName.$error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  (_ctx.v$.user.userName.required)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass({ 'is-invalid': _ctx.v$.user.userName.$error })
                      }, " Enter a valid username ", 2))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.step === 3)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("ul", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.credentials, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item.id
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    name: "item.id",
                    value: item.id,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedCredential) = $event))
                  }, null, 8, _hoisted_10), [
                    [_vModelRadio, _ctx.selectedCredential]
                  ]),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(item.question), 1)
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.step === 4)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("label", _hoisted_13, [
              _createTextVNode(_toDisplayString(_ctx.challengeInstructions) + " ", 1),
              (_ctx.challengeQuestionId > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                    _createVNode(_component_ToolTip, { tooltipText: "Enter your answer below and click continue" })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: _normalizeClass(["form-control type-number", _ctx.v$.user.code.$error ? 'is-invalid' : 'input-text']),
              id: "code",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.user.code) = $event)),
              onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.v$.user.code.$touch()))
            }, null, 34), [
              [_vModelText, _ctx.user.code]
            ]),
            (_ctx.v$.user.code.$error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  (_ctx.v$.user.code.required)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass({ 'is-invalid': _ctx.v$.user.code.$error })
                      }, _toDisplayString(_ctx.challengeInstructions), 3))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.step === 5)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("label", _hoisted_17, [
              _createTextVNode(_toDisplayString(_ctx.user.securityQuestion), 1),
              _createVNode(_component_ToolTip, { tooltipText: "Answer your security question and click next to continue." })
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: _normalizeClass(["form-control type-number", _ctx.v$.user.securityAnswer.$error ? 'is-invalid' : 'input-text']),
              id: "securityAnswer",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.user.securityAnswer) = $event)),
              onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.v$.user.securityAnswer.$touch()))
            }, null, 34), [
              [_vModelText, _ctx.user.securityAnswer]
            ]),
            (_ctx.v$.user.securityAnswer.$error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  (_ctx.v$.user.securityAnswer.required)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass({ 'is-invalid': _ctx.v$.user.securityAnswer.$error })
                      }, " Enter an answer to the question ", 2))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _withDirectives(_createVNode(_component_vue_recaptcha, {
            class: "w-100",
            size: "normal",
            sitekey: _ctx.googleRecaptchaKey,
            theme: "light",
            "loading-timeout": _ctx.loadingTimeout,
            onVerify: _ctx.recaptchaVerified,
            onExpire: _ctx.recaptchaExpired,
            onFail: _ctx.recaptchaFailed,
            onError: _ctx.recaptchaError,
            ref: "vueRecaptcha"
          }, null, 8, ["sitekey", "loading-timeout", "onVerify", "onExpire", "onFail", "onError"]), [
            [_vShow, _ctx.showRecaptcha]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("button", {
          name: "backBtn",
          class: "btn back-btn btn-primary w-20",
          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.backButtonHandler && _ctx.backButtonHandler(...args)))
        }, " BACK "),
        _createElementVNode("button", {
          type: "submit",
          disabled: _ctx.v$.user.userName.$invalid || _ctx.isSubmitDisabled,
          class: _normalizeClass(["btn w-80", [_ctx.buttonDesign()]]),
          id: "button-continue",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.activeCallBack()))
        }, _toDisplayString(_ctx.buttonLabel), 11, _hoisted_22)
      ])
    ], 32)
  ]))
}